import { render, staticRenderFns } from "./ReceiptStage4.vue?vue&type=template&id=2e2c4f55&scoped=true&"
import script from "./ReceiptStage4.vue?vue&type=script&lang=js&"
export * from "./ReceiptStage4.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptStage4.vue?vue&type=style&index=0&id=2e2c4f55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c4f55",
  null
  
)

export default component.exports